// extracted by mini-css-extract-plugin
export default {"global_container":"App_global_container__TvFBX"};